import { useModal } from 'mui-modal-provider';
import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';

import { CvModalInfo } from '../../components/business/app/cv-modals';
import { InternalLinks } from '../../constants';
import { EcpServices } from '../../components/business/app/ecp-locator';

interface CvModalProps {
  points: number;
  fromDays: number;
  toDays: number;
  endDate: string;
  onNavigateToEcp?: () => void;
  code: string;
  isLoading: boolean;
}

export const useCvInfoModal = ({
  points,
  endDate,
  fromDays,
  toDays,
  onNavigateToEcp,
  code,
  isLoading,
}: CvModalProps) => {
  const { showModal } = useModal();
  const navigate = useNavigate();

  const handleCvDetailsClick = useCallback((): void => {
    if (isLoading) {
      return;
    }

    showModal(CvModalInfo, {
      points,
      endDate,
      fromDays,
      toDays,
      onNavigateToEcp: () => onNavigateToEcp ? onNavigateToEcp() : navigate(
        `${InternalLinks.ecpLocator}?ecpService=${EcpServices.cv}&storeGroupCode=${code}`,
      ),
      onNavigateToAppointment: () => navigate(InternalLinks.appointment),
    });
  }, [showModal, points, endDate, fromDays, toDays, navigate, onNavigateToEcp, code, isLoading]);

  return { handleCvDetailsClick };
};
